import "./table.css";
import { Controller as BaseController } from "@hotwired/stimulus";

const toNumber = (value) => parseInt(value, 10);

export class Controller extends BaseController {
  static targets = ["checkbox"];
  static outlets = ["export--trait-selector"];
  static values = {
    listMode: Boolean,
    rowsCount: Number,
    totalRowsCount: Number,
  };

  initialize() {
    this.selectedAllEnabled = false;
    this.selectedIds = new Set();
    // Prevent throwing errors in the console
    this.selectAllTarget = this.element.querySelector(
      '[data-search--table-target="selectAll"]'
    );
  }

  connect() {
    console.debug("connect", this.rowsCountValue, this.totalRowsCountValue);
    if (this.listModeValue) {
      this.selectAllTarget.checked = true;
      this.selectAllTarget.indeterminate = true;
      this.checkboxTargets.forEach((checkbox) => {
        checkbox.checked = true;
        this.selectedIds.add(toNumber(checkbox.value));
      });
      this.saveState();
    }

    // HOTFIX because table is in turbo frame but not the rest of the page
    if (this.hasExportTraitSelectorOutlet) {
      this.exportTraitSelectorOutlet.listModeValue = this.listModeValue;
      this.exportTraitSelectorOutlet.totalRowsCountValue =
        this.totalRowsCountValue;
    }

    const storedSelectAll = localStorage.getItem("selectAll");
    const storedSelectedIds = localStorage.getItem(
      this.listModeValue ? "listIds" : "selectedIds"
    );

    this.selectedAllEnabled = storedSelectAll
      ? JSON.parse(storedSelectAll)
      : false;
    this.selectedIds = storedSelectedIds
      ? new Set(JSON.parse(storedSelectedIds))
      : new Set();

    this.applySelections();
    this.updateOutlet();
  }

  applySelections() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = this.selectedAllEnabled
        ? !this.selectedIds.has(toNumber(checkbox.value))
        : this.selectedIds.has(toNumber(checkbox.value));
    });

    if (this.selectAllTarget) {
      if (this.selectedAllEnabled) {
        this.selectAllTarget.checked = true;
        this.selectAllTarget.indeterminate = false;
      } else if (this.selectedIds.size > 0) {
        this.selectAllTarget.checked = false;
        this.selectAllTarget.indeterminate = true;
      } else {
        this.selectAllTarget.checked = false;
        this.selectAllTarget.indeterminate = false;
      }
    }
  }

  toggleAll(event) {
    this.selectedAllEnabled = event.target.checked;
    this.selectedIds.clear();
    this.applySelections();
    this.saveState();
  }

  toggleOne(event) {
    const checkbox = event.target;

    if (this.selectedAllEnabled) {
      checkbox.checked
        ? this.selectedIds.delete(toNumber(checkbox.value))
        : this.selectedIds.add(toNumber(checkbox.value));
    } else {
      checkbox.checked
        ? this.selectedIds.add(toNumber(checkbox.value))
        : this.selectedIds.delete(toNumber(checkbox.value));
    }

    this.applySelections();
    this.saveState();
  }

  saveState() {
    localStorage.setItem("selectAll", JSON.stringify(this.selectedAllEnabled));
    if (this.listModeValue) {
      localStorage.setItem("listIds", JSON.stringify([...this.selectedIds]));
    } else {
      localStorage.setItem(
        "selectedIds",
        JSON.stringify([...this.selectedIds])
      );
    }
    this.updateOutlet();
  }

  updateOutlet() {
    if (this.hasExportTraitSelectorOutlet) {
      this.exportTraitSelectorOutlet.updateTaxonsCount(
        this.selectedIds.size,
        this.selectedAllEnabled
      );
    }
  }
}
